import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "ja", // サポート外の言語だったときのデフォルト
    debug: process.env.NODE_ENV === "development",
    detection: {
      // ここで順序を定義する
      order: ["querystring"],
      lookupQuerystring: "lng",
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        common: require("./locales/en/common.json"),
        chi: require("./locales/en/chi.json"),
      },
      ja: {
        common: require("./locales/ja/common.json"),
        chi: require("./locales/ja/chi.json"),
        yofukashi: require("./locales/ja/yofukashi.json"),
        jashindp: require("./locales/ja/jashindp.json"),
        higurashi: require("./locales/ja/higurashi.json"),
        potion: require("./locales/ja/potion.json"),
        omagun: require("./locales/ja/omagun.json"),
      },
      ko: {
        common: require("./locales/ko/common.json"),
        chi: require("./locales/ko/chi.json"),
      },
      "zh-TW": {
        common: require("./locales/zh-TW/common.json"),
        chi: require("./locales/zh-TW/chi.json"),
      },
    },
  });

export default i18n;
